var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { css } from 'styled-components';
import { ANIMATIONS } from './animations';
import { DURATION_VALUES } from './tokens';
export function animate(animation, options) {
  if (options === void 0) {
    options = {};
  }
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n  "], ["\n    ", "\n    ", "\n  "])), ANIMATIONS[animation], Object.entries(optionsFactory(options)).map(function (_a) {
    var option = _a[0],
      value = _a[1];
    return "".concat(option, ": ").concat(value, ";");
  }));
}
export function optionsFactory(options) {
  var _a = options.duration,
    duration = _a === void 0 ? 'medium' : _a,
    _b = options.delay,
    delay = _b === void 0 ? 0 : _b;
  return {
    'animation-duration': DURATION_VALUES[duration],
    'animation-delay': "".concat(delay, "s")
  };
}
var templateObject_1;